// extracted by mini-css-extract-plugin
export default {"container":"ID_container__G8bsD","userDetailsContainer":"ID_userDetailsContainer__QEgYy","sdgContainer":"ID_sdgContainer__RD2eE"};